import React from 'react';

const BG_VIDEO_URL = "https://customer-assets.emergentagent.com/job_24a5c19e-c98b-489e-9b60-ee49ca73b23a/artifacts/gg0927h8_Life%20Care%20And%20Wellness%20Background%20Video.mp4";

const VideoBackground = ({ children, variant = "light", className = "" }) => {
  const overlay = variant === "dark"
    ? "rgba(44, 80, 35, 0.82)"
    : "rgba(255, 255, 255, 0.78)";

  return (
    <section className={`relative overflow-hidden ${className}`}>
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
        src={BG_VIDEO_URL}
      />
      <div className="absolute inset-0" style={{ backgroundColor: overlay }} />
      <div className="relative z-10">{children}</div>
    </section>
  );
};

export default VideoBackground;
